
import React from "react";
import { Button } from "@/components/ui/button";
import { FormInput, Plus } from "lucide-react";

interface EmptyStateProps {
  onCreateForm: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ onCreateForm }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="bg-indigo-50 dark:bg-indigo-900/20 p-4 rounded-full mb-4">
        <FormInput className="w-10 h-10 text-indigo-500 dark:text-indigo-400" />
      </div>
      <h3 className="text-xl font-medium mb-2">Aucun formulaire créé</h3>
      <p className="text-gray-500 dark:text-gray-400 mb-6 max-w-md">
        Créez un formulaire personnalisable pour collecter les informations de vos clients directement sur vos pages produits.
      </p>
      <Button 
        onClick={onCreateForm}
        className="flex items-center gap-2"
      >
        <Plus className="h-4 w-4" />
        Créer un formulaire
      </Button>
    </div>
  );
};
